import React from 'react';
import { limitNumberOfCharacters } from '../../utils/strings';
import { WORKFLOW_MODAL_TOOLTIP_DEFAULT_LIMIT_CHARS } from './workflow-modal-tooltip.constants';
import { Info, InfoTextTooltip, TooltipTriangle } from './workflow-modal-tooltip.styles';

interface WorkflowModalTooltipProps {
    text: string;
    top?: string;
    right?: string;
    bottom?: string;
    left?: string;
    className?: string;
    limitCharactersNumber?: number;
}

const WorkflowModalTooltip = ({
    text, top, right, bottom, left, className, limitCharactersNumber,
}: WorkflowModalTooltipProps) => (
    <Info
        top={top}
        right={right}
        left={left}
        bottom={bottom}
        className={className}
    >
        <TooltipTriangle />
        <InfoTextTooltip>{text !== undefined
            && limitNumberOfCharacters(text, limitCharactersNumber
            || WORKFLOW_MODAL_TOOLTIP_DEFAULT_LIMIT_CHARS)}
        </InfoTextTooltip>
    </Info>
);

WorkflowModalTooltip.defaultProps = {
    bottom: 'unset',
    left: 'unset',
    right: 'unset',
    top: 'unset',
};

export default WorkflowModalTooltip;
